"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const R = react_1.default.createElement;
const react_select_1 = __importDefault(require("react-select"));
const mapSymbols_1 = require("./mapSymbols");
// Allows selecting of map marker symbol
class MarkerSymbolSelectComponent extends react_1.default.Component {
    render() {
        // Create options
        const options = (0, mapSymbols_1.getMapSymbols)();
        const optionRenderer = (option) => R("span", null, R("i", { className: `fa fa-${option.value.substr(13)}` }), // Trim "font-awesome/"
        ` ${option.label}`);
        return R("div", { className: "mb-3" }, R("label", { className: "text-muted" }, R("span", { className: "fa fa-star" }), " ", T `Symbol`), R(react_select_1.default, {
            placeholder: T `Circle`,
            value: lodash_1.default.findWhere(options, { value: this.props.symbol }) || null,
            options,
            formatOptionLabel: optionRenderer,
            isClearable: true,
            onChange: (opt) => this.props.onChange(opt?.value || null)
        }));
    }
}
exports.default = MarkerSymbolSelectComponent;
